import { render, staticRenderFns } from "./DmSelect.vue?vue&type=template&id=67ce4daa&scoped=true&"
import script from "./DmSelect.vue?vue&type=script&lang=js&"
export * from "./DmSelect.vue?vue&type=script&lang=js&"
import style0 from "./DmSelect.vue?vue&type=style&index=0&id=67ce4daa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce4daa",
  null
  
)

export default component.exports